import React, { useEffect, useState, useRef } from 'react';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export function FadeIn({
  children,
  delay = 0,
  className = '',
  direction = 'up'
}: FadeInProps) {
  const [isVisible, setIsVisible] = useState(false);
  const domRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add a small delay if specified
          setTimeout(() => {
            setIsVisible(true);
          }, delay);
          // Unobserve after revealing
          if (domRef.current) {
            observer.unobserve(domRef.current);
          }
        }
      });
    }, {
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.1
    });
    const currentRef = domRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [delay]);
  const getTransform = () => {
    if (isVisible) return 'translate(0, 0)';
    switch (direction) {
      case 'up':
        return 'translateY(30px)';
      case 'down':
        return 'translateY(-30px)';
      case 'left':
        return 'translateX(30px)';
      case 'right':
        return 'translateX(-30px)';
      case 'none':
        return 'none';
      default:
        return 'translateY(30px)';
    }
  };
  return <div ref={domRef} className={className} style={{
    opacity: isVisible ? 1 : 0,
    transform: getTransform(),
    transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
  }} data-id="element-156">
      {children}
    </div>;
}